import { Sprite, Texture } from 'pixi.js';

import { Shared } from '../App';

export default class DiamondSprite extends Sprite
{
    static from(texture: Texture): Sprite
    {
        const ret = super.from(texture);
        const shine = Sprite.from(Shared.assets.getTexture('currency-shine'));

        shine.anchor.set(0.5);
        shine.scale.set(0.5);
        shine.x = 15;
        shine.y = -10;
        ret.addChild(shine);

        return ret;
    }
}
